import * as React from 'react';
import { InjectedRouter, PlainRoute } from 'react-router';

import AdminDefaultClassSettingsContainer from './AdminDefaultClassSettingsContainer';
import AdminDefaultClassSettingsView from './AdminDefaultClassSettingsView';
import { OrganizationType } from 'globalTypes';
import { withRouter } from 'app/context/Router';

type Props = {
  organizationUUID: string;
  orgType: OrganizationType;
  route: PlainRoute;
  router: InjectedRouter;
};

function AdminDefaultClassSettings(props: Props) {
  return (
    <AdminDefaultClassSettingsContainer organizationUUID={props.organizationUUID}>
      {({ classesDefaultSettings, activeGroupCount, setOrgClassDefaults }) => (
        <AdminDefaultClassSettingsView
          orgType={props.orgType}
          classesDefaultSettings={classesDefaultSettings}
          activeGroupCount={activeGroupCount}
          setOrgClassDefaults={setOrgClassDefaults}
          orgUuid={props.organizationUUID}
          route={props.route}
          router={props.router}
        />
      )}
    </AdminDefaultClassSettingsContainer>
  );
}

export { AdminDefaultClassSettings };

export default withRouter(AdminDefaultClassSettings);
